
<table class="mainTable">
  <tr>
    <td style="width: 15%"></td>
    <td style="width: 70%">
        <table style="min-width: 100%; max-width: 100%;margin-top: 1.5%">
            <tr>
              <td colspan="4" style="min-width: 100%; max-width: 100%">
                    <mat-card class="topBanner2" style="cursor: pointer" *ngIf="showCharts" xmlns="http://www.w3.org/1999/html">
                      <div class="two-col" >
                        <div class="col1" style="width: 25%; padding-top: 20px; text-align: -webkit-left">
                          <span class="underTitleFont" style="text-align: center; padding-top: 15px">Today's Gate Activity</span>
                        </div>
                        <div class="col2" style="text-align: right; width: 75%">
                          <mat-label style="color: white; padding-right: 20px; font-weight: bold">Yard Area:</mat-label>
                          <mat-form-field class="newField " style=" font-size: 17px; color: white; border: #FFFFFF solid 1px; background-color: white;  " appearance="outline;" >
                            <mat-select  [(value)]="savedList"  style="color: white; padding-left: 5px" (selectionChange)="changeYard()">
                              <mat-option class="myOption" style="color: #FFFFFF" *ngFor="let lr of savedLists" [value]="lr.code">{{lr.description}}</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                      </div>
                    </mat-card>
              </td>
            </tr>
            <tr>
                  <td style="max-width: 25%; min-width: 25%; text-align: -webkit-center; text-align: -moz-center">
                        <mat-card class="topSquaresDemo" style="cursor: pointer" *ngIf="showCharts" (click)="goToGate('COMPLETED')">
                          <div class="divPad">
                            <div class="completed" style="padding-bottom: 10px;"></div>
                          </div>
                          <div class="titleFont" style="padding-top:20px;  text-align: -webkit-center">{{completed}}</div>
                          <div style="width: 100%; text-align: center">
                            <div class="titleFont" style="padding-bottom: 10px;overflow: hidden ">______</div>
                          </div>

                          <div class="underTitleFont" style="text-align: -webkit-center">Completed</div>
                        </mat-card>
                  </td>
                  <td style="max-width: 25%; min-width: 25%; text-align: -webkit-center; text-align: -moz-center">
                        <mat-card class="topSquaresDemo" style="cursor: pointer" *ngIf="showCharts" (click)="goToGate('IN PROGRESS')">
                          <div class="divPad">
                            <div class="inProgress" style="padding-bottom: 10px;"></div>
                          </div>
                          <div class="titleFont" style="padding-top:20px;  text-align: -webkit-center">{{in_progress}}</div>
                          <div style="width: 100%; text-align: center; overflow: hidden">
                            <div class="titleFont" style="padding-bottom: 10px; ">______</div>
                          </div>  <div class="underTitleFont" style="text-align: -webkit-center">In Progress</div>
                        </mat-card>
                  </td>
                  <td style="max-width: 25%; min-width: 25%; text-align: -webkit-center; text-align: -moz-center">
                        <mat-card class="topSquaresDemo" style="cursor: pointer" *ngIf="showCharts" (click)="goToGate('CANCELLED')">
                          <div class="divPad">
                            <div class="cancelled" style="padding-bottom: 10px;"></div>
                          </div>
                          <div class="titleFont" style="padding-top:20px;  text-align: -webkit-center">{{cancelled}}</div>
                          <div style="width: 100%; text-align: center">
                            <div class="titleFont" style="padding-bottom: 10px; overflow: hidden">______</div>
                          </div>  <div class="underTitleFont" style="text-align: -webkit-center">Canceled</div>
                        </mat-card>
                  </td>
                  <td style="max-width: 25%; min-width: 25%; text-align: -webkit-center; text-align: -moz-center">
                        <mat-card class="topSquaresDemo" style="cursor: pointer" *ngIf="showCharts" (click)="goToGate('TROUBLE')">
                          <div class="divPad">
                            <div class="trouble" style="padding-bottom: 10px;"></div>
                          </div>
                          <div class="titleFont" style="padding-top:20px;  text-align: -webkit-center">{{trouble}}</div>
                          <div style="width: 100%; text-align: center">
                            <div class="titleFont" style="padding-bottom: 10px; overflow: hidden">______</div>
                          </div>  <div class="underTitleFont" style="text-align: -webkit-center">Clerical </div>
                        </mat-card>
                  </td>
            </tr>
            <tr>
              <td  style="min-width: 20%; max-width: 20%"></td>
              <td colspan="2" style="min-width: 60%; max-width: 60%; text-align: -webkit-center">
                      <mat-card class="topSquaresDemo" *ngIf="showCharts" style="  padding: 0px; width: 91%">
                        <div class="titleFont2" style="text-align: center; padding-bottom: 5px">Gate Moves</div>
                        <div class="lowerCaseLetters"  style="font-size: 14px; color: white; text-align: center">click on move type for more details</div>
                        <div >
                          <div style="text-align: -webkit-center;text-align: -moz-center; ">
                            <div  >
                              <canvas baseChart class="mainChart" #myChart
                                      [type]="barChartType"
                                      [legend]="barChartLegend"
                                      [plugins]="barChartPlugins"
                                      [labels]="barChartLabels"
                                      [datasets]="barChartData"
                                      [options]="barChartOptions"
                                      (chartClick)="onChartClick($event)"

                              >
                              </canvas>
                            </div>
                          </div>
                        </div>
                      </mat-card>
              </td>
              <td  style="min-width: 20%; max-width: 20%"></td>

            </tr>


        </table>
    </td>
    <td style="width: 15%"></td>

  </tr>

</table>
<script>
  const ctx = document.getElementById('myChart');

  new Chart(ctx, {
    type: 'bar',
    data: {
      labels: ['Red', 'Blue', 'Yellow', 'Green', 'Purple', 'Orange'],
      datasets: [{
        label: '# of Votes',
        data: [12, 19, 3, 5, 2, 3],
        borderWidth: 1
      }]
    },
    options: {
      scales: {
        y: {
          beginAtZero: true
        }
      }
    }
  });
</script>


<!--
<mat-card class="topBanner" style="cursor: pointer" *ngIf="showCharts" xmlns="http://www.w3.org/1999/html">
  <div class="two-col" >
    <div class="col1" style="width: 25%; padding-top: 20px; text-align: -webkit-left">
      <span class="underTitleFont" style="text-align: center; padding-top: 15px">Today's Gate Activity</span>
    </div>
    <div class="col2" style="text-align: right; width: 75%">
      <mat-label style="color: white; padding-right: 20px; font-weight: bold">Yard Area:</mat-label>
      <mat-form-field class="newField " style=" font-size: 17px; color: white; border: #FFFFFF solid 1px; background-color: white;  " appearance="outline;" >
        <mat-select  [(value)]="savedList"  style="color: white; padding-left: 5px" (selectionChange)="changeYard()">
          <mat-option class="myOption" style="color: #FFFFFF" *ngFor="let lr of savedLists" [value]="lr.code">{{lr.description}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
</div>
</mat-card>

<mat-card class="topSquares" style="cursor: pointer" *ngIf="showCharts" (click)="goToGate('COMPLETED')">
        <div class="divPad">
          <div class="completed" style="padding-bottom: 10px;"></div>
        </div>
          <div class="titleFont" style="padding-top:20px;  text-align: center">{{completed}}</div>
          <div style="width: 100%; text-align: center">
            <div class="titleFont" style="padding-bottom: 10px;overflow: hidden ">______</div>
          </div>

          <div class="underTitleFont" style="text-align: center">Completed</div>
</mat-card>

<mat-card class="topSquares2" style="cursor: pointer" *ngIf="showCharts" (click)="goToGate('IN PROGRESS')">
  <div class="divPad">
    <div class="inProgress" style="padding-bottom: 10px;"></div>
  </div>
  <div class="titleFont" style="padding-top:20px;  text-align: center">{{in_progress}}</div>
  <div style="width: 100%; text-align: center; overflow: hidden">
    <div class="titleFont" style="padding-bottom: 10px; ">______</div>
  </div>  <div class="underTitleFont" style="text-align: center">In Progress</div>
</mat-card>

<mat-card class="topSquares3" style="cursor: pointer" *ngIf="showCharts" (click)="goToGate('CANCELLED')">
  <div class="divPad">
    <div class="cancelled" style="padding-bottom: 10px;"></div>
  </div>
  <div class="titleFont" style="padding-top:20px;  text-align: center">{{cancelled}}</div>
  <div style="width: 100%; text-align: center">
    <div class="titleFont" style="padding-bottom: 10px; overflow: hidden">______</div>
  </div>  <div class="underTitleFont" style="text-align: center">Cancelled</div>
</mat-card>

<mat-card class="topSquares4" style="cursor: pointer" *ngIf="showCharts" (click)="goToGate('TROUBLE')">
  <div class="divPad">
    <div class="trouble" style="padding-bottom: 10px;"></div>
  </div>
  <div class="titleFont" style="padding-top:20px;  text-align: center">{{trouble}}</div>
  <div style="width: 100%; text-align: center">
    <div class="titleFont" style="padding-bottom: 10px; overflow: hidden">______</div>
  </div>  <div class="underTitleFont" style="text-align: center">Clerical </div>
</mat-card>




<mat-card class="speech-bubble2" *ngIf="showCharts">


        <div class="titleFont2" style="text-align: center; padding-bottom: 5px">Gate Moves</div>
        <div class="lowerCaseLetters"  style="font-size: 14px; color: white; text-align: center">click on move type for more details</div>


  <div >
    <div style="text-align: center;">
      <div  >
        <canvas *ngIf="barChartData" baseChart class="mainChart" #myChart
                [datasets]="barChartData"
                [labels]="barChartLabels"
                [plugins]="barChartPlugins"

             (chartClick)="onChartClick($event)"
                [options]="barChartOptions"
                [legend]="barChartLegend"
                [chartType]="barChartType"

        >

        </canvas>
      </div>
    </div>
  </div>
</mat-card>
-->















<!--

<mat-card class="speech-bubble">
  <div class="email"></div>
  <div class="titleFont" style="padding-bottom: 10px; padding-left: 28%">bcl gate moves by type </div>
  <div class="flex">
  <div class="flex-item">
    <div style="display: block;">
      <canvas baseChart class="mainChart"
              [datasets]="lineChartData"
              [labels]="lineChartLabels"
              [options]="lineChartOptions"
              [colors]="lineChartColors"
             [legend]="lineChartLegend"
              [chartType]="lineChartType"
              (chartHover)="chartHovered($event)"
              ></canvas>
    </div>
  </div>
</div>
</mat-card>


<mat-card class="speech-bubble2">
  <div class="titleFont" style="padding-bottom: 40px; padding-left: 35%">bcl gate errors </div>

  <div>
  <div>
    <div style="display: block" >
      <canvas baseChart class="mainChart"
              [datasets]="barChartData"
              [labels]="barChartLabels"
              [plugins]="barChartPlugins"
              [options]="barChartOptions"
              [legend]="barChartLegend"
              [chartType]="barChartType">
      </canvas>
    </div>
  </div>
</div>
</mat-card>


<mat-card class="speech-bubble3">
  <div class="titleFont" style="padding-bottom: 20px; padding-left: 26%">bcl total containers </div>

  <div>
    <div>
      <div class="chart">
        <canvas baseChart
                [data]="pieChartData"
                [labels]="pieChartLabels"
                [chartType]="pieChartType"
                [options]="pieChartOptions"
                [colors]="pieChartColors"
                [legend]="pieChartLegend">
        </canvas>
      </div>
    </div>
  </div>
</mat-card>
-->
